import type { AccountSummary, UserAccount } from '@paid-ui/types';

import { proxy } from 'valtio';
import { devtools } from 'valtio/utils';

import { TransactionAccountMatcherType } from '@paid-ui/enums/account';

import { userManager } from './user';

const initialState = {
  // This id is account matcher ID
  id: '',
  accountId: '',
  availableBalance: 0,
  reservedBalance: 0,
  totalBalance: 0,
  bsb: '',
  accountNumber: '',
  accountCreationTime: '',
  /** The account may only be funded internally, so it has no BSB or account number. */
  internalPaymentsOnly: false,
  /** Force update flag */
  forceUpdate: 0,
  loading: true,
  /** Full user accounts list from GET /transaction-account */
  accounts: [] as UserAccount[],
};

export const getMainMatcher = (account: UserAccount | undefined) =>
  account?.matchers?.find((matcher) => matcher.type === TransactionAccountMatcherType.MAIN);

export const transactionAccountManager = proxy(initialState);

devtools(transactionAccountManager, {
  name: 'Main Transaction Account',
  enabled: false,
});

export const resetTransactionAccount = () => {
  Object.assign(transactionAccountManager, initialState);
};

export const saveAccountSummary = (data: AccountSummary) => {
  transactionAccountManager.availableBalance = data.availableBalance;
  transactionAccountManager.reservedBalance = data.reservedBalance;
  transactionAccountManager.totalBalance = data.totalBalance;
  // The summary still carries the BSB and account number even for an internal
  // payments only account, so don't write back what the account list masked.
  if (!transactionAccountManager.internalPaymentsOnly) {
    transactionAccountManager.bsb = data.bsb;
    transactionAccountManager.accountNumber = data.accountNumber;
  }
  if (data.accountCreationTime) {
    transactionAccountManager.accountCreationTime = data.accountCreationTime;
  }
  transactionAccountManager.loading = false;
};

export const stopLoading = () => {
  transactionAccountManager.loading = false;
};

export const saveUserAccounts = (accounts: UserAccount[]) => {
  transactionAccountManager.accounts = accounts;
  transactionAccountManager.loading = false;
};

export const reloadTransactionAccount = () => {
  const { forceUpdate } = transactionAccountManager;
  const { isAccountViewable } = userManager;
  if (!isAccountViewable) return;
  transactionAccountManager.loading = true;
  transactionAccountManager.forceUpdate = forceUpdate > 100 ? 1 : forceUpdate + 1;
};
